let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fIejC")).then(() => parcelRequire('k9qTQ'));